import { render, staticRenderFns } from "./empty-bookings-found.vue?vue&type=template&id=947b620c&scoped=true&"
import script from "./empty-bookings-found.vue?vue&type=script&lang=js&"
export * from "./empty-bookings-found.vue?vue&type=script&lang=js&"
import style0 from "./empty-bookings-found.vue?vue&type=style&index=0&id=947b620c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947b620c",
  null
  
)

export default component.exports